import { FhsAxios } from "../../services/axios";
import moment from "moment";
import { hasItBeenLoaded } from "@/helpers/loading";

export default {
  state: {
    income: null,
    incomeErrorMessage: "",
    incomeSinceYearBeginning: null,
    incomeSinceYearBeginningError: null,
    incomeDateRange: [
      moment()
        .subtract(1, "year")
        .format("DD.MM.YYYY"),
      moment()
        .subtract(1, "months")
        .format("DD.MM.YYYY")
    ],
    incomeType: 0
  },
  actions: {
    fetchIncomeData(
      { commit, getters, state },
      dateRange = getters.formatedIncomeDateRange
    ) {
      commit("unsetIncomeData");
      if (hasItBeenLoaded(state.income)) {
        return;
      }

      // Создаем базовый url для запроса
      let url = "user/get-income";
      let currency = getters.displayingCurrency;
      let incomeType = state.incomeType;
      // Если пользователь - VIP и пользователь выбрал определенного брокера, добавляем в запрос ID брокера (получаем данные только по выбранному брокеру)
      if (
        getters.selectedPortfolio !== "all" &&
        getters.selectedPortfolio !== undefined
      ) {
        url += "/" + getters.selectedPortfolio;
      }
      FhsAxios.post(url, {
        ...dateRange,
        currency,
        p_year: incomeType
      }).then(response => {
        let income;
        try {
          if (response.data.result.income.error !== "") {
            commit("setIncomeErrorMessage", response.data.result.income.error);
          } else {
            commit("setIncomeErrorMessage", "");
            income = response.data.result.income.values;
          }
        } catch (e) {
          income = [];
        }
        commit("setIncomeData", income);
      });
    },
    clearIncomeData({ commit }) {
      commit("unsetIncomeData");
    },
    // Функция для получения доходности с начала года
    fetchIncomeSinceYearBeginning({ commit, getters }) {
      commit("unsetIncomeSinceYearBeginning", null);
      commit("unsetIncomeSinceYearBeginningError", null);
      let currency = getters.displayingCurrency;
      FhsAxios.post("user/get-income-ytd/" + getters.selectedPortfolio, {
        userId: getters.userId,
        currency
      }).then(response => {
        commit(
          "setIncomeSinceYearBeginning",
          response.data.result.income.profit
        );
        commit(
          "setIncomeSinceYearBeginningError",
          response.data.result.income.error
        );
      });
    },
    // Добавляем в глобальное хранилище выбранный отрезок времени
    setIncomeDateRange({ commit }, dateRange) {
      commit("setIncomeDateRange", dateRange);
    },
    setIncomeType({ commit }, type) {
      commit("setIncomeType", type);
    }
  },
  mutations: {
    setIncomeType(state, type) {
      state.incomeType = type;
    },
    setIncomeData(state, income) {
      state.income = income;
    },
    unsetIncomeData(state) {
      state.income = null;
    },
    setIncomeDateRange(state, dateRange) {
      state.incomeDateRange = dateRange;
    },
    setIncomeErrorMessage(state, message) {
      state.incomeErrorMessage = message;
    },
    setIncomeSinceYearBeginning(state, incomeValue) {
      state.incomeSinceYearBeginning = incomeValue;
    },
    unsetIncomeSinceYearBeginning(state) {
      state.incomeSinceYearBeginning = null;
    },
    setIncomeSinceYearBeginningError(state, errorMessage) {
      state.incomeSinceYearBeginningError = errorMessage;
    },
    unsetIncomeSinceYearBeginningError(state) {
      state.incomeSinceYearBeginningError = "";
    }
  },
  getters: {
    incomeData(state) {
      return state.income;
    },
    isIncomeLoading(state) {
      return state.income === null;
    },
    incomeDateRange(state) {
      return state.incomeDateRange;
    },
    // Возвращаем дату в удобном виде для API
    formatedIncomeDateRange(state) {
      if (!state.incomeDateRange) {
        return {};
      }
      return {
        bDate: state.incomeDateRange[0],
        eDate: state.incomeDateRange[1]
      };
    },
    incomeChartOptions(state) {
      let income = state.income;
      // Отлавливаем ошибки
      if (!income) {
        income = [];
      }

      return {
        title: {
          text: ""
        },
        yAxis: {
          title: {
            text: ""
          },
          labels: {
            format: "{value} %"
          }
        },
        xAxis: {
          type: "datetime",
          dateTimeLabelFormats: {
            day: "%d.%m.%y",
            week: "%d.%m.%y",
            month: "%b %Y",
            year: "%Y"
          }
        },
        tooltip: {
          pointFormat: "<b>{point.y:.2f}%</b>"
        },
        legend: {
          enabled: false
        },
        series: [
          {
            name: "",
            data: income.map(incomeItem => {
              let date = moment(incomeItem.date, "DD.MM.YYYY");

              return [
                Date.UTC(date.year(), date.month(), date.date()),
                state.incomeType == 0
                  ? Number(incomeItem.profit)
                  : Number(incomeItem.profit_year)
              ];
            })
          }
        ]
      };
    },
    // Возвращаем последние данные о доходности, чтобы отобразить ввиде цифры после графика
    lastProfitability(state) {
      let income = state.income;
      if (!income || income.length === 0) {
        return "";
      }
      return income[income.length - 1].profit;
    },
    incomeErrorMessage(state) {
      return state.incomeErrorMessage;
    },
    incomeSinceYearBeginning(state) {
      return state.incomeSinceYearBeginning;
    },
    incomeSinceYearBeginningError(state) {
      return state.incomeSinceYearBeginningError;
    }
  }
};
